import { atom } from "recoil";

export const claimModalIsOpen = atom<boolean>({
    key: "ui/claimModalIsOpen",
    default: false,
});
